import { CapitalGlobalProposalPage } from '@/features/proposals/components/capital-global/capital-global-proposal-page.component';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/proposals/$id/capital-global/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.proposals.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <CapitalGlobalProposalPage policyId={id} mode='view' />;
}
